import Api from './Api';

const END_POINT = 'inventories';

export default {
    get_all(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}`, request);
    },
    
    async store(data) {
        return await Api.post(`${END_POINT}`, data);
    },

    async get_kardex (filters) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}/kardex`, request);
    },
}